import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface ICopyDashboard {
    day?: number
    date?: string
    leader_count?: number
    r_leader_count?: number
    copier_count?: number
    managed_asset?: number
    trade_volume?: number
    trade_count?: number
    average?: number
    average_per_copier?: number
    earned?: number
    avg_earned?: number
    profit?: number
    median?: number
}

export const getCopyDashboard = async (limit: number, dataType: string): Promise<ApiRes<ICopyDashboard[]>> => {
    return await apiGet(API_URL, `admin/copy/graph?limit=${limit}&type=${dataType}`)
}
